import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["spinner", "icon"]

  connect() {
    this.boundShow = this.showSpinner.bind(this)
    this.boundHide = this.hideSpinner.bind(this)
    this.element.addEventListener('ajax:send', this.boundShow)
    this.element.addEventListener('ajax:complete', this.boundHide)
  }

  disconnect() {
    this.element.removeEventListener('ajax:send', this.boundShow)
    this.element.removeEventListener('ajax:complete', this.boundHide)
  }

  showSpinner() {
    this.submitButtons().forEach(button => button.classList.add('is-submitting'))
    this.spinnerTarget.classList.remove('d-none')
    if (this.hasIconTarget) this.iconTarget.classList.add('d-none')
    this.element.classList.add('c-button--loading')
  }

  hideSpinner() {
    this.submitButtons().forEach(button => button.classList.remove('is-submitting'))
    this.spinnerTarget.classList.add('d-none')
    if (this.hasIconTarget) this.iconTarget.classList.remove('d-none')
    this.element.classList.remove('c-button--loading')
  }

  submitButtons() {
    return Array.from(this.element.querySelectorAll('button[type="submit"], input[type="submit"]'))
  }
}
